export const API_TIMEOUT = 60000; // 1 minute
export const EXTENDED_API_TIMEOUT = API_TIMEOUT * 10; // 10 minutes
export enum EnvType {
  BETA = 'beta',
  DEFAULT = 'default',
  QA = 'qa',
  UAT = 'uat',
}

export enum AGraphEnvType {
  ALPHA = 'alpha',
  BETA = 'beta',
  STABLE = 'stable',
}

export enum AGraphAcceptType {
  ALPHA = 'application/vnd.blackrock.alpha+json',
  BETA = 'application/vnd.blackrock.beta+json',
}

export const API_KEY_HEADER = 'VND.com.blackrock.API-Key';
export const ORIGIN_TIME_STAMP_HEADER = 'VND.com.blackrock.Origin-Timestamp';
export const CHANNEL_HEADER = 'VND.com.blackrock.Channel';
export const STRIPE_HEADER = 'VND.com.blackrock.Stripe';
export const REQUEST_ID_HEADER = 'VND.com.blackrock.Request-ID';
export const TRACEPARENT_HEADER = 'TraceParent';
export const ACCEPT_HEADER = 'Accept';
export const LOGIN_HEADER_KEY = 'login';

export const CHATBLK_API_URL = process.env?.AWAPI_CHATBLK_API_URL || '/api/ux/ai/chatblk';
export const APP_CONTAINER_SERVICE_URL =
  process.env?.AWAPI_APP_CONTAINER_SERVICE || '/varnish-api/app-container-service';
export const CHAT_BLK_STATUS_PATH =
  process.env?.VITE_CHAT_BLK_STATUS_PATH || '/us/financial-professionals/chatblk-status.json';
